import instance from "../config";

// metodo para trae todos los user
const getUsers = async (params) => {
    try {
        const response = await instance.get('/api/users', { params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
}

//Metodo para registrar un user 
const postUser = async (data) => {
    try {
        const response = await instance.post('/auth/registro', data)
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}

const editarUserApi = async (id,data) => { 
    try {
         const response = await instance.patch(`/auth/login/${id}`, data );
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}


const deleteUserApi = async (id) => { 
    try {
         const response = await instance.delete(`/api/user/${id}`);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}

const gatUserApi = async (id) => { 
    try {
         const response = await instance.get(`/api/user/${id}`);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}
export {
    getUsers,
    postUser,
    editarUserApi,
    deleteUserApi,
    gatUserApi,
}